export const PRODUCT_CARD_SIZES =
  "(max-width: 639px) calc(100vw - 2rem), (max-width: 1023px) calc(50vw - 1.5rem), (max-width: 1279px) 33vw, 25vw";

export const PRODUCT_GRID_SIZES =
  "(max-width: 1023px) calc(50vw - 1.5rem), (max-width: 1279px) 33vw, 25vw";

export const LANDING_CARD_SIZES = "(max-width: 639px) 171px, 260px";

export const PRODUCT_CARD_SCROLL_SIZES = "(max-width: 639px) 260px, 280px";

export const LISTING_GALLERY_SIZES = "(max-width: 1024px) 100vw, 50vw";

export const BROWSE_CARD_SIZES = {
  map: "(max-width: 1023px) calc(50vw - 1.5rem), (max-width: 1279px) calc(33.333vw - 1.5rem), (max-width: 1439px) calc(22.222vw - 1.334rem), calc((100vw - 480px - 4rem) / 3)",
  full: "(max-width: 1023px) calc(50vw - 1.5rem), (max-width: 1279px) calc((100vw - 4rem) / 3), (max-width: 1535px) calc((100vw - 5rem) / 4), calc((100vw - 6rem) / 5)",
};
